enum TriggerType {
    Time = 0,
    Queue = 1,
    Mail = 2
}

const TriggerTypeValue = {
    GetText: (typeNumber: number) => {
        return TriggerType[typeNumber].valueOf()
    }
}

export default TriggerTypeValue